module.exports = __webpack_public_path__ + "static/img/Banner_PS_LineFriend.bf8bf58.jpg";